
<div class="mt-4 mb-3">
    <div *ngIf="hasAudience()">
  <p *ngFor="let data of results">
      <a *ngIf="data.assetTypeId == 2" class="tittle1 font-weight-bold"  rel="noopener noreferrer" (click)="onMedialinkClick(data.url)"style="display:block"> {{data.assetName}}.pdf</a>
  </p> 
</div>
<div class="tittle1 font-weight-bold" *ngIf="!hasAudience()">No Audience</div>
   </div>